import { createSlice } from "@reduxjs/toolkit";
import { checkCompletingReferences } from "./references.thunks";
import { DirectoryEmptinessResponse } from "libs/apiClient/data-contracts";

interface ReferencesState {
	references: DirectoryEmptinessResponse;
	isIncompleteReferences: boolean;
}

const initialState: ReferencesState = {
	references: {
		organisationsPresent: false,
		employeesPresent: false,
		usersPresent: false,
		rolesPresent: false,
		activityAreasPresent: false,
		ownershipTypesPresent: false,
		documentPatternsPresent: false,
		personStatusesPresent: false,
		constructionObjectsPresent: false,
		orgMarkersPresent: false,
		objectStatusesPresent: false,
		threatConsequencesPresent: false,
		objectTypesPresent: false,
		threatsPresent: false,
		inapplicabilityReasonsPresent: false,
		significanceCriteriaPresent: false,
		okvedCodesPresent: false,
	},
	isIncompleteReferences: false,
};

const referencesSlice = createSlice({
	name: "referencesSlice",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(checkCompletingReferences.fulfilled, (state, action) => {
			state.references = action.payload;

			const results = Object.values(action.payload);
			if (results.includes(false)) {
				state.isIncompleteReferences = true;
			} else {
				state.isIncompleteReferences = false;
			}
		});
	},
});

export default referencesSlice.reducer;
